import { render, staticRenderFns } from "./RetailStripShopRetailProperty.vue?vue&type=template&id=04490bcb&scoped=true&"
import script from "./RetailStripShopRetailProperty.vue?vue&type=script&lang=ts&"
export * from "./RetailStripShopRetailProperty.vue?vue&type=script&lang=ts&"
import style0 from "./RetailStripShopRetailProperty.vue?vue&type=style&index=0&id=04490bcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04490bcb",
  null
  
)

export default component.exports